const LiveOnlineStatistics = () => import('@/views/main/live/liveOnlineStatistics/LiveOnlineStatistics.vue')
export default {
  path: '/main/liveOnlineStatistics',
  name: 'LiveOnlineStatistics',
  component: LiveOnlineStatistics,
  children: []
}
